// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vdp-datepicker .form-control:disabled{color:#d1d2db;background-color:#f4f5fd!important;opacity:.7}", ""]);
// Exports
module.exports = exports;
